import MasterDimensi from "../../../../../components/categories/siakad/laporan_adab/master_dimensi/Home";
export default function Home() {
  
  return (
    <MasterDimensi />
  );
}
